import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ListBuyersParams } from 'src/app/core/buyers.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';

@Component({
  selector: 'app-buyers-filter-dialog',
  templateUrl: './buyers-filter-dialog.component.html',
  styleUrls: ['./buyers-filter-dialog.component.scss'],
})
export class BuyersFilterDialogComponent {
  buyers_filter_from_group: FormGroup = this.form_service.buyers_filter_from_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;

  constructor(
    private dialog_ref: MatDialogRef<BuyersFilterDialogComponent>,
    private form_service: FormService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {}

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onApplyFiltersClick(): void {
    if (this.isFormValid()) {
      const buyer_id: string | '' = this.buyers_filter_from_group.get(this.form_service.buyer_id_label)?.value;
      const buyer_name: string | '' = this.buyers_filter_from_group.get(this.form_service.buyer_name_label)?.value;
      const phone_value: string | '' = this.buyers_filter_from_group.get(this.form_service.phone_value_label)?.value;
      const email: string | '' = this.buyers_filter_from_group.get(this.form_service.email_label)?.value;
      const onboarding_completed_from_text: string = this.buyers_filter_from_group.get(
        this.form_service.onboarding_completed_from_label,
      )?.value;
      const onboarding_completed_to_text: string = this.buyers_filter_from_group.get(
        this.form_service.onboarding_completed_to_label,
      )?.value;
      const onboarding_completed_from: number = new Date(onboarding_completed_from_text).getTime();
      const onboarding_completed_to: number = new Date(onboarding_completed_to_text).setHours(23, 59, 59, 999);

      const params: ListBuyersParams = {
        buyer_id: buyer_id == '' ? undefined : buyer_id,
        buyer_name: buyer_name == '' ? undefined : buyer_name,
        phone_value: phone_value == '' ? undefined : phone_value,
        email: email == '' ? undefined : email,
        onboarding_completed_from:
          !onboarding_completed_from_text || onboarding_completed_from_text == ''
            ? undefined
            : onboarding_completed_from.toString(),
        onboarding_completed_to:
          !onboarding_completed_to_text || onboarding_completed_to_text == ''
            ? undefined
            : onboarding_completed_to.toString(),
      };

      console.log('Applying buyers filters:', params);
      this.dialog_ref.close({ params });
    }
  }

  onClearFiltersClick(): void {
    this.buyers_filter_from_group.reset();
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.buyers_filter_from_group);
  }
}
